import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usage-instructions',
  templateUrl: './usage-instructions.component.html',
  styleUrls: ['./usage-instructions.component.scss']
})
export class UsageInstructionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
